import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getAllShiftsRequest: null,
  getAllShiftsSuccess: ['response'],
  getAllShiftsFailure: null,

  getUserShiftsRequest: ['day'],
  getUserShiftsSuccess: ['response'],
  getUserShiftsFailure: null,

  getShiftRequest: ['shiftId'],
  getShiftSuccess: ['response'],
  getShiftFailure: null,

  createShiftRequest: ['payload'],
  createShiftSuccess: ['response'],
  createShiftFailure: null,

  updateShiftRequest: ['shiftId', 'payload'],
  updateShiftSuccess: ['response'],
  updateShiftFailure: ['shiftId'],

  deleteShiftRequest: ['shiftId'],
  deleteShiftSuccess: ['shiftId'],
  deleteShiftFailure: ['shiftId'],

  clearSuccessGetUserShiftsRequest: null,

  clearSuccessSubmitShiftRequest: null,

  // Clear all caches
  clearShiftsRequest: null,
});

export const ShiftsTypes = Types;
export default Creators;
